import {Modal} from 'react-bootstrap'
import {SignatureFormRequestContent} from './SignatureFormRequestContent'
import {NodeSignatureFormsEntry} from '../../../types/signatureFormsEntriesApi'

export const ModalRequestSignature: React.FC<{
  keyboard: boolean
  backdrop: boolean | 'static' | undefined
  onClose: () => void
  refetch: () => void
  isOpen: boolean
  sourceType: string
  sourceId: string
  preAgentId?: string
  hasEmail?: boolean
  hasPhone?: boolean
  resendEntryId?: NodeSignatureFormsEntry
}> = ({
  keyboard,
  backdrop,
  sourceType,
  sourceId,
  preAgentId,
  isOpen,
  onClose,
  refetch,
  hasEmail,
  hasPhone,
  resendEntryId,
}) => {
  // console.log('sourceType:' + sourceType)
  // console.log('MRS hasEmail:' + hasEmail + ' hasPhone:' + hasPhone)
  return (
    <Modal show={isOpen} onHide={onClose} size='xl' backdrop={backdrop} keyboard={keyboard}>
      <Modal.Header closeButton>
        <Modal.Title>Request Signature</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SignatureFormRequestContent
          onClose={onClose}
          refetch={refetch}
          sourceType={sourceType}
          sourceId={sourceId}
          preAgentId={preAgentId}
          hasEmail={hasEmail}
          hasPhone={hasPhone}
          resendEntryId={resendEntryId}
        />
      </Modal.Body>
    </Modal>
  )
}
